<div class="contact-list-item">
    <label tam-checkbox (click)="onCheckBoxClick()" class="checkbox" [(ngModel)]="checkboxValue"></label>
</div>